// import { isHindiText } from "api/commonConstants";
import debounce from "debounce";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import styled from "styled-components";
import DOMPurify from 'dompurify'
import { baseUrlV2 } from "api/constants";

const Wrapper = styled.div`
  .modal {
    height: 250px;
    width: 350px;
  }

  .modalfooter .btn {
    width: 10rem !important;
  }
`;

const LIMITS = {
  topSearch : 5,
  trendingTopics : 5,
  topNews : 5,
  topShows : 5,
  favouriteAnchor : 5
}


// LOCAL COMPONENTS START
const SearchOverlay = ({data , setShowSearchPopup , setShowSearch}) => {

  const ref = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      
      if (ref.current && !ref.current.contains(event.target)) {
        
        // props?.setComment(false); // Close the sidebar
        setShowSearch(false)
        setShowSearchPopup(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  const SearchDropdown = () => {
    return <div style={{
      padding: '10px',
      maxHeight: '165px',
      overflowY: 'auto',
      overflowX: 'hidden',
      position: 'absolute',
      zIndex: 1000,
      backgroundColor: 'white',
      width: '85%',
      top: '55px',
      boxShadow: '5px 5px 6px rgba(0, 0, 0, 0.1)', // example shadow
      // display: 'none' // uncomment to hide
    }} 
    >
    <ul>

      {/* SEARCH TEXT RESULTS  */}
      {dropdownListText &&
        dropdownListText.slice(0, 5).map((item, index) => (
          <a
            href={item.permalink}
            key={index}
            passHref={true}
            style={{fontSize : "14px"}}
          >
            <li key={index}>
              Article:&nbsp;
              <a onClick={() => setSearchText("")}>
                <span style={{color : "#333333"}}>{item?.title}</span>
              </a>
            </li>
            <hr />
          </a>
        ))}

      
      {/* SEARCH VIDEO RESULTS  */}
      {dropdownListVideo &&
        dropdownListVideo.slice(0, 5).map((item, index) => (
          <li  style={{fontSize : "14px"}} key={index}>
            <span style={{color : "#007bff"}}>Video:&nbsp;</span>
            <a href={item.permalink} passHref={true}>
              <a onClick={() => setSearchText("")}>
                <span style={{color : "#333333"}}>{item?.title}</span>
              </a>
            </a>
            <hr />
          </li>
        ))}

        {/* SEARCH AUDIO RESULTS  */}
      {dropdownListAudio &&
        dropdownListAudio.slice(0, 5).map((item, index) => (
          <li  style={{fontSize : "14px"}} key={index}>
            <span style={{color : "#007bff"}}>Audio:&nbsp;</span>
            <a href={item.permalink} passHref={true}>
              <a onClick={() => setSearchText("")}>
                <span style={{color : "#333333"}}>{item?.title}</span>
              </a>
            </a>
            <hr />
          </li>
        ))}

        {/* SEARCH SHOWS RESULTS  */}
        {dropdownListShows &&
        dropdownListShows.slice(0, 5).map((item, index) => (
          <li  style={{fontSize : "14px"}} key={index}>
            <span style={{color : "#007bff"}}>Shows:&nbsp;</span>
            <a href={item.permalink} passHref={true}>
              <a onClick={() => setSearchText("")}>
                <span style={{color : "#333333"}}>{item?.title}</span>
              </a>
            </a>
            <hr />
          </li>
        ))}


        {/* SEARCH AUTHORS RESULTS  */}
        {dropdownListAuthors &&
        dropdownListAuthors.slice(0, 5).map((item, index) => (
          <li  style={{fontSize : "14px"}} key={index}>
            <span style={{color : "#007bff"}}>Authors:&nbsp;</span>
            <a href={item.permalink} passHref={true}>
              <a onClick={() => setSearchText("")}>
                <span style={{color : "#333333"}}>{item?.title}</span>
              </a>
            </a>
            <hr />
          </li>
        ))}
    </ul>
  </div>
  }


  const [dropdownListText, setDropdownListText] = useState([]);
  const [dropdownListVideo, setDropdownListVideo] = useState([]);
  const [dropdownListAudio, setDropdownListAudio] = useState([]);
  const [dropdownListShows , setDropdownListShows] = useState([])
  const [dropdownListAuthors , setDropdownListAuthors] = useState([])
  const [showDropdown , setShowDropdown] = useState(false)
  const [searchText , setSearchText] = useState("")

  
  const fetchSearchSuggestions = debounce(async (text) => {
    fetch(
      `${baseUrlV2}/search/dropdown?limit=10&search=${encodeURIComponent(text)}&sortField=publishedAt&sortOrder=desc`
    )
      .then((res) => res.json())
      .then((d) => {
        console.log("dis", d?.result?.data);
        setDropdownListText(d?.result?.data?.textSuggestions);
        setDropdownListVideo(d?.result?.data?.videoSuggestions);
        setDropdownListAudio(d?.result?.data?.audioSuggestions);
        setDropdownListShows(d?.result?.data?.seriesSuggestions)
        setDropdownListAuthors(d?.result?.data?.authorSuggestions)
        setShowDropdown(true)
      });
  }, 300);

  const router = useRouter();
  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "Enter") {
        router.push({
          pathname: "/search",
          query: { title: searchText },
        });
        setSearchText("");
        setShowSearchPopup(false)
        setShowDropdown(false)
      }
    },
    [searchText, setSearchText]
  );

  useEffect(() => {
    if (searchText) {
      fetchSearchSuggestions(searchText);
    }
    else{
      setShowDropdown(false)
    }
  }, [searchText]);


  return (
    <div style={{
      position: 'fixed',
      top: '5%',
      bottom : "2%",
      left: '50%',
      transform: 'translateX(-50%)',
      width: '50%',
      maxWidth: '960px',
      backgroundColor: '#fff',
      borderRadius: '12px',
      padding: '10px 30px',
      boxShadow: '0 4px 30px rgba(0,0,0,0.2)',
      zIndex: 1000,
      fontFamily: 'sans-serif',
      overflowY : "auto",
      // maxHeight : "747px",
      maxHeight : "fit-content",
      overflowX : "hidden"
    }}
    id="search-popup"
    ref={ref}>
      {/* Search Bar */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #ddd',
        paddingBottom: '10px'
      }}>
        <span style={{ color: '#cc2071', marginRight: '10px', fontSize: '18px' }}>
          <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.222 11.6813L10.8879 9.36612C11.794 8.23645 12.2327 6.80258 12.114 5.35934C11.9953 3.9161 11.3281 2.5732 10.2497 1.60676C9.17125 0.640321 7.76352 0.123803 6.31595 0.163414C4.86838 0.203024 3.491 0.795753 2.46703 1.81972C1.44305 2.84369 0.850325 4.22107 0.810715 5.66864C0.771104 7.11621 1.28762 8.52394 2.25406 9.60237C3.22051 10.6808 4.56341 11.348 6.00665 11.4667C7.44989 11.5854 8.88376 11.1466 10.0134 10.2406L12.3287 12.5558C12.3871 12.6148 12.4567 12.6616 12.5334 12.6936C12.6101 12.7255 12.6923 12.7419 12.7753 12.7419C12.8584 12.7419 12.9406 12.7255 13.0173 12.6936C13.094 12.6616 13.1635 12.6148 13.222 12.5558C13.3354 12.4385 13.3988 12.2818 13.3988 12.1186C13.3988 11.9554 13.3354 11.7987 13.222 11.6813ZM6.48398 10.2406C5.61296 10.2406 4.7615 9.98233 4.03727 9.49842C3.31304 9.01451 2.74857 8.3267 2.41525 7.52199C2.08192 6.71727 1.99471 5.83178 2.16464 4.9775C2.33457 4.12322 2.754 3.33851 3.36991 2.7226C3.98581 2.1067 4.77052 1.68726 5.62481 1.51734C6.47909 1.34741 7.36458 1.43462 8.1693 1.76795C8.97402 2.10127 9.66182 2.66574 10.1457 3.38996C10.6296 4.11419 10.8879 4.96565 10.8879 5.83667C10.8879 7.00467 10.4239 8.12483 9.59805 8.95073C8.77214 9.77663 7.65198 10.2406 6.48398 10.2406Z" fill="#D9368B"/>
          </svg>
        </span>
        <input
          type="text"
          placeholder="आर्टिकल, वीडियो, शोज़, पॉडकास्ट और ऑथर्स सर्च करें"
          onChange={(event) => {
            const sanitizedValue = DOMPurify.sanitize(event.target.value)
            setSearchText(sanitizedValue)
          }}
          onKeyDown={handleKeyDown}
          style={{
            flex: 1,
            fontSize: '14px',
            border: 'none',
            outline: 'none'
          }}
          value={searchText}
        />
        {searchText && <Clear setSearchText = {setSearchText}/>}
        {<span onClick={() => {setShowSearch(false)
        setShowSearchPopup(false)}} style={{ fontSize: '20px', color: '#cc2071', cursor: 'pointer' }}>
            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.379883 11.1786C0.379128 11.1379 0.382225 11.0973 0.389648 11.0575L0.424805 10.9403C0.44023 10.9026 0.458865 10.8665 0.481445 10.8329L0.55957 10.7391H0.560547L4.7666 6.57506L4.8916 6.45201L4.76758 6.32799L0.560547 2.12193L0.55957 2.11998L0.486328 2.03307C0.422079 1.94037 0.38464 1.83084 0.379883 1.71666C0.380615 1.58152 0.421136 1.45053 0.495117 1.33971L0.581055 1.23619C0.709147 1.1081 0.882377 1.03553 1.06348 1.03502C1.1838 1.03657 1.30053 1.07326 1.39941 1.13951L1.49219 1.21568L5.79688 5.52037L5.91992 5.39635L10.0869 1.22935C10.1153 1.19914 10.147 1.17212 10.1807 1.1483L10.2881 1.08678C10.3637 1.05354 10.4457 1.03613 10.5283 1.03502C10.6645 1.03517 10.7966 1.07572 10.9082 1.15025L11.0127 1.23619C11.1409 1.36469 11.2129 1.539 11.2129 1.72057V1.7235C11.2137 1.76445 11.2106 1.80551 11.2031 1.84557L11.1689 1.96178C11.1535 1.99944 11.1339 2.03559 11.1113 2.0692L11.0332 2.16295L11.0322 2.16393L6.82617 6.32701L6.70117 6.45103L6.8252 6.57506L11.0322 10.7811L11.0332 10.7821C11.1422 10.8887 11.2054 11.0332 11.2119 11.1854C11.2113 11.3206 11.1716 11.4515 11.0977 11.5624L11.0127 11.6669C10.8841 11.7954 10.7091 11.868 10.5273 11.868V11.8671L10.5205 11.868C10.4777 11.8698 10.4346 11.8673 10.3926 11.8602L10.2705 11.826C10.2306 11.8104 10.1919 11.7908 10.1562 11.7674L10.0576 11.6864L5.9209 7.5067L5.79688 7.3817L1.49902 11.6796C1.47068 11.7088 1.43962 11.7356 1.40625 11.7587L1.2998 11.8172C1.2251 11.8494 1.14481 11.8661 1.06348 11.8671C0.928002 11.8667 0.796708 11.8268 0.685547 11.7528L0.581055 11.6669C0.45258 11.5384 0.379966 11.3642 0.379883 11.1825V11.1786Z" fill="#EB0E8C" stroke="#EB0E8C" stroke-width="0.349462"/>
            </svg>
        </span>}
      </div>

      {/* Subtitle */}
      {/* <p style={{ fontSize: '14px', color: '#393939', marginTop: '10px' }}>
      सर्च करें आर्टिकल्स, वीडिओज़, शोज़, पॉडकास्ट, ऑथर्स
      </p> */}

      {showDropdown && <SearchDropdown/>}

      {/* Top Searches */}
      <div style={{ marginTop: '10px' }}>
        <strong style={{ fontSize: '14px' , fontWeight : "700" }}>🔍 टॉप सर्च</strong>
        <div style={{ flexWrap: 'nowrap' , display : "flex" , overflowX : "auto" , gap : "5px" , marginTop : "4px"  }}>
          {data?.seoKeywords?.map(tag => (
            <span key={tag} 
            onClick={() => {
              router.push({
                pathname: "/search",
                query: { title: tag },
              });
              setSearchText("");
              setShowSearchPopup(false)
              setShowDropdown(false)
            }}
            style={{
              display: 'inline-block',
              // backgroundColor: '#fce4ef',
              color: '#666D73',
              padding: '6px 12px',
              // margin: '6px',
              borderRadius: '5px',
              fontSize: '12.58px',
              fontWeight :  "400",
              border : "0.7px solid #EB0E8C",
              cursor : "pointer",
              height : "fit-content",
              whiteSpace : "nowrap"
            }}>{tag}</span>
          ))}
        </div>
      </div>

      {/* Trending Topics */}
      <div style={{ marginTop: '10px'  }}>
        <strong style={{ fontSize: '14px'  , fontWeight : "700" }}>🔥 ट्रेंडिंग टॉपिक्स</strong>
        <div style={{ flexWrap: 'wrap' , display : "flex" , overflowX : "auto" , gap : "5px" , marginTop : "4px"  }}>
          {data?.quickLinks?.map((tag, index) => (
            <span key = {index} onClick={() => {
              window.location.href = tag?.url
            }}  style={{
              display: 'inline-block',
              // backgroundColor: '#fce4ef',
              color: '#666D73',
              padding: '6px 12px',
              // margin: '6px',
              borderRadius: '5px',
              fontSize: '12.58px',
              fontWeight :  "400",
              border : "0.7px solid #EB0E8C",
              cursor : "pointer",
              height : "fit-content",
              whiteSpace : "nowrap"
            }}>{tag?.title}</span>
          ))}
        </div>
      </div>

      {/* Top News */}
      <div style={{ marginTop: '10px' , position : "relative" }}>
        <h3 style={{marginBottom :"5px" , fontSize : "12px" , fontWeight : "700" , color : "#d9368b" ,  display: 'flex',gap : "5px" ,  alignItems: 'center' }}>          
          <svg width="19" height="19" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5104 2.53165H7.41183C5.50517 2.52432 3.94225 4.04415 3.89733 5.9499V15.7701C3.85517 17.7071 5.39058 19.3121 7.3275 19.3552C7.35592 19.3552 7.38342 19.3561 7.41183 19.3552H14.7351C16.6546 19.2773 18.1671 17.6915 18.1533 15.7701V7.36798L13.5104 2.53165Z" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.2695 2.52084V5.18742C13.2695 6.48909 14.3219 7.54417 15.6235 7.54784H18.1489" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.0984 14.0786H8.14844" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.2228 10.6388H8.14648" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        <span>लेटेस्ट खबरें</span>
        
        </h3>
        <AurDekhe url = {"latest?type=text"}/>
        <div style={{ display: 'flex', gap: '15px', overflowX: 'auto' , scrollbarWidth : "none" }}>
          {data?.textPosts?.map((item,index) => (
            <div key={index} style={{
              // minWidth: '200px',
              maxWidth : "140px",
              minWidth : "140px",
              overflow: 'hidden',
              backgroundColor: '#fff',
              marginBottom : "5px"
             
            }}>
              <TopNewsCard item = {item}/>
            </div>
          ))}
        </div>
      </div>

       {/* Top News */}
       <div style={{ marginTop: '10px' , position : "relative" }}>
        <h3 style={{marginBottom :"5px" , fontSize : "12px" , fontWeight : "700" , color : "#d9368b" ,  display: 'flex',gap : "5px" ,  alignItems: 'center' }}>          
          {/* <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5104 2.53165H7.41183C5.50517 2.52432 3.94225 4.04415 3.89733 5.9499V15.7701C3.85517 17.7071 5.39058 19.3121 7.3275 19.3552C7.35592 19.3552 7.38342 19.3561 7.41183 19.3552H14.7351C16.6546 19.2773 18.1671 17.6915 18.1533 15.7701V7.36798L13.5104 2.53165Z" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.2695 2.52084V5.18742C13.2695 6.48909 14.3219 7.54417 15.6235 7.54784H18.1489" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.0984 14.0786H8.14844" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.2228 10.6388H8.14648" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg> */}

            <svg width="19" height="19" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.63193 0.8909C14.0633 0.8909 17.6569 4.48369 17.6569 8.9159C17.6569 13.3481 14.0633 16.9409 9.63193 16.9409C5.19972 16.9409 1.60693 13.3481 1.60693 8.9159C1.60693 4.48369 5.19972 0.8909 9.63193 0.8909Z" stroke="#EB0E8C" stroke-width="1.68947" stroke-linecap="round" stroke-linejoin="round"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1661 8.91179C12.1661 8.2266 8.6541 6.0346 8.25571 6.42873C7.85731 6.82287 7.81901 10.9636 8.25571 11.3949C8.6924 11.8276 12.1661 9.59698 12.1661 8.91179Z" stroke="#EB0E8C" stroke-width="1.68947" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

        <span>लेटेस्ट वीडियो</span>
        
        </h3>
        <AurDekhe url = {"latest?type=video"}/>
        <div style={{ display: 'flex', gap: '15px', overflowX: 'auto' , scrollbarWidth : "none" }}>
          {data?.videoPosts?.map((item,index) => (
            <div key={index} style={{
              // minWidth: '200px',
              maxWidth : "140px",
              minWidth : "140px",
              overflow: 'hidden',
              backgroundColor: '#fff',
              marginBottom : "5px"
             
            }}>
              <TopNewsCard item = {item}/>
            </div>
          ))}
        </div>
      </div>

      {/* Top Shows */}
      <div style={{ marginTop: '10px' , position : "relative"}}>
        <h3 style={{marginBottom :"5px" ,  fontSize : "12px" , fontWeight : "700" , color : "#d9368b" ,  display: 'flex', gap : "5px" , alignItems: 'center' }}>
          
        <svg width="19" height="19" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.3327 13.3129V8.31289C18.3327 4.14622 16.666 2.47955 12.4993 2.47955H7.49935C3.33268 2.47955 1.66602 4.14622 1.66602 8.31289V13.3129C1.66602 17.4796 3.33268 19.1462 7.49935 19.1462H12.4993C16.666 19.1462 18.3327 17.4796 18.3327 13.3129Z" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2.09961 6.73788H17.8996" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.09961 2.57123V6.62123" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.9004 2.57123V6.24623" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.125 12.8546V11.8546C8.125 10.5712 9.03333 10.0462 10.1417 10.6879L11.0083 11.1879L11.875 11.6879C12.9833 12.3296 12.9833 13.3796 11.875 14.0212L11.0083 14.5212L10.1417 15.0212C9.03333 15.6629 8.125 15.1379 8.125 13.8546V12.8546V12.8546Z" stroke="#EB0E8C" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

          <span>टॉप शोज़</span>
        </h3>
        <AurDekhe url = {"show"}/>
        <div style={{ display: 'flex', gap: '10px', overflowX: 'auto', padding: '0px 0px' ,  scrollbarWidth : "none" }}>
          {data?.series?.map((item,index) => {
            
            return <div key={index} style={{
              // minWidth: '200px',
              maxWidth : "140px",
              minWidth : "140px",
              overflow: 'hidden',
              backgroundColor: '#fff',
             
            }}><TopShowsCard item = {item} setShowSearch = {setShowSearch} setShowSearchPopup = {setShowSearchPopup}/></div>
             
          })}
        </div>
      </div>

     

      {/* Your Favourite Anchor */}
      {/* <div style={{ marginTop: '10px' , position : "relative"}}>
        <h3 style={{  fontSize : "18px" , fontWeight : "700" , color : "#d9368b" ,  display: 'flex', gap : "5px" ,  alignItems: 'center' }}>
          
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.63411 9.87073C7.55078 9.8624 7.45078 9.8624 7.35911 9.87073C5.37578 9.80407 3.80078 8.17907 3.80078 6.17907C3.80078 4.1374 5.45078 2.47906 7.50078 2.47906C9.54245 2.47906 11.2008 4.1374 11.2008 6.17907C11.1924 8.17907 9.61745 9.80407 7.63411 9.87073Z" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.6747 4.14673C15.2914 4.14673 16.5914 5.45506 16.5914 7.0634C16.5914 8.6384 15.3414 9.92173 13.7831 9.98006C13.7164 9.97173 13.6414 9.97173 13.5664 9.98006" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.46758 12.9467C1.45091 14.2967 1.45091 16.4967 3.46758 17.8384C5.75925 19.3717 9.51758 19.3717 11.8092 17.8384C13.8259 16.4884 13.8259 14.2884 11.8092 12.9467C9.52591 11.4217 5.76758 11.4217 3.46758 12.9467Z" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.2852 17.4791C15.8852 17.3541 16.4518 17.1124 16.9185 16.7541C18.2185 15.7791 18.2185 14.1707 16.9185 13.1957C16.4602 12.8457 15.9018 12.6124 15.3102 12.4791" stroke="#EB0E8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

          <span>
          आपके पसंदीदा एंकर
          </span>
        </h3>
        <AurDekhe url = {"authors"}/>
        <div style={{ display: 'flex', gap: '10px', overflowX: 'auto', marginTop: '10px' , paddingBottom : "5px" , scrollbarWidth : "none" }}>
          {data?.authors?.map((item,index) => (
            <div key={index} style={{ textAlign: 'center',  maxWidth : "150px" }}>
              <ProfileCard item = {item}  imageUrl={item?.profileImage} title = {item?.fullname}/>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export const TopNewsCard = ({item}) => {
  return <>
    <div onClick={() => {
      window.location.href = item?.permalink
    }} style={{
      
      width : "100%",
      overflow : "hidden",
      borderRadius : "5px",
      cursor : "pointer"
    }} >
  <img style={{
    aspectRatio : "16:9",
    width : "100%",
    height : "100%",
    objectFit : "cover",
    maxHeight : "78.4px",
    minHeight : "78.4px"
  }} src={item?.headingImageUrl + "?width=200"} alt="Image with 16:9 aspect ratio"/>
</div>
    {/* <img style={{width : "171px" , height : "96px"}} src="https://static.thelallantop.com/images/post/1748240068303_screenshot_2025-05-26_083912.webp?width=200" alt="" /> */}
    <p onClick={() => {
      window.location.href = item?.permalink
    }} style={{
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      fontSize : "14px",
      fontWeight : "600",
      marginBottom : "0px",
      marginTop : "5px",
      cursor : "pointer"
    }}>{item?.title}</p>
  </>
}


export const TopShowsCard = ({item , setShowSearch , setShowSearchPopup}) => {
  return <>
    <div onClick={() => {
      // setShowSearch(false)
      // setShowSearchPopup(false)
      window.location.href = `/show/detail/${item?.postSlug?.toLowerCase()}`
    }} style={{
     
      width : "100%",
      overflow : "hidden",
      borderRadius : "5px",
      cursor : "pointer"
    }} >
  <img style={{
    width : "100%",
    aspectRatio : "16:9",
    // maxHeight : "95.76px",
    maxHeight : "78.4px",
    objectFit : "cover"
  }} src={item?.headingImageUrl + "?width=200"} alt="Image with 16:9 aspect ratio"/>
</div>
  </>
}

export const ProfileCard = ({ imageUrl, title , item }) => {
  const cardStyle = {
    width: '100px',
    padding: '10px 10px',
    backgroundColor: 'white',
    borderRadius: '16px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
    cursor : "pointer"
  };

  const imageContainerStyle = {
    width: '50px',
    height: '50px',
    margin: '0 auto 10px',
    border: '3px solid #ff0080',
    borderRadius: '50%',
    padding: '3px',
    boxSizing: 'border-box',
    overflow: 'hidden'
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '50%'
  };

  const titleStyle = {
    fontSize: '13px',
    fontWeight: 'normal',
    color: '#000',
    whiteSpace : "nowrap",
    overflowX : "hidden"
    
   
  };

  return (
    <div onClick={() => {
      window.location.href = `/authors/${item?.username}?${item?._id}`
    }} style={cardStyle}>
      <div style={imageContainerStyle}>
        <img src={imageUrl} alt="Profile" style={imageStyle} />
      </div>
      <div style={titleStyle}>{title}</div>
    </div>
  );


}


export const AurDekhe = ({url}) => {
  return <div onClick={() => {
    window.location.href = `/${url}`
  }} style={{position : "absolute" , top : "5px" , right : "1px" , cursor : "pointer" , fontSize : "12px"}}>
    <span style={{color : "#868686" , marginRight : "5px"}}>और देखें</span>
    <span>
        <svg width="15" height="15" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.525391" y="0.5" width="19.9727" height="19" rx="9.5" fill="white" stroke="#999999"/>
        <path d="M9.53516 6L13.4361 9.8L9.53516 14" stroke="#999999" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</span>
  </div>
}

export const Clear = ({setSearchText}) => {
  return <button onClick={() => setSearchText("")} style={{ 
    backgroundColor:'rgb(241, 242, 250)', 
    padding:'2px 9px', 
    border:'none', 
    borderRadius:'4px', 
    marginRight:'10px', 
    cursor:'pointer',
    fontSize : "13px",
    fontWeight : "200"
  }}>Clear</button>
}



// LOCAL COMPONENTS END

const SearchPopup = ({ showModal = true, onClose , masterConfig  , setShowSearchPopup , setShowSearch}) => {

  const [showPopup , setShowPopup] = useState(false)
  const [data , setData] = useState(null)

  useEffect(() => {
    const fetchLandingScreen = async () => {
      try {
        const response = await fetch(`${baseUrlV2}/search/landingScreen?seriesLimit=7&authorsLimit=7`);
        const json = await response.json();

        if (json.status) {
          setData(json.result);
        } else {
          console.error('search landing API Error:', json.message);
          setData(null);
        }
      } catch (error) {
        console.error('search landing Fetch Error:', error);
        setData(null);
      }
    };

    fetchLandingScreen();
  }, []);
  const router = useRouter();
  return  (
    <Wrapper  >
      <Modal
        contentClassName=""
        show={showModal}
        centered
        dialogClassName="frist-login"
        
      >
       {data ? <SearchOverlay data = {data} setShowSearchPopup = {setShowSearchPopup} setShowSearch = {setShowSearch} /> : <div className="lds-dual-ring"></div>}     
      </Modal>
    </Wrapper>
  ) 
};

export default SearchPopup;
